import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';


@Injectable()
export class CommunicationService {

    constructor() { }
    public emitChangeSource = new Subject<any>();
    public emitSideBarSource = new Subject<any>();
    public emitChangeValue = new Subject<any>();
    public emitArgsChanges = new Subject<any>();
    public emitResetResource = new Subject<any>();
    public resetOtpForm = new Subject<any>();
    public cartData = new Subject<any>();
    public machine_id = new Subject<any>();
    public componentClass = new Subject<any>();
    public emitBtnArgs = new Subject<any>();
    public calendarResource = new BehaviorSubject<any>(0);
    public bannerRefersh = new Subject<any>();
    public storagevalue = new Subject<any>();
    public appendHtml = new Subject<any>();
    public isCims = new BehaviorSubject<boolean>(false);
    public itemInvalid = new Subject<any>();
    public billAuthData = new Subject<any>();
    public removeBillData$ = new Subject<any>();
    public PoData$ = new Subject<any>();
    public grnData$ = new Subject<any>();
    public prData$ = new Subject<any>();
    public indentData$ = new Subject<any>();
    public getDepenedentDetails = new Subject<any>();
    public kycStatus$ = new Subject<any>();
    public machineDate$ = new Subject<any>();
    public updateCompositeArrayOutSource = new Subject<any>();
    public currentBtnValue$ = new Subject<any>();
    public emrOpthalmic_data$ = new Subject<any>();
    public commonViwerData$ = new Subject<any>();
    public clearCart$ = new Subject<any>();
    public slotDetails$ = new Subject<any>();
    public consigmentDetails$ = new BehaviorSubject<any>([]);
    public consignmentChallanIssueData$ = new Subject<any>();
    public consigmentReturnDetails$ = new BehaviorSubject<any>([]);
    public getTokenNotification$ = new Subject<any>();
    public multipleSlotCount$ = new Subject<any>();
    public accessionIdentifierReady$ = new Subject<string>(); /* Subject for broadcasting changes to the procedure accession identifier */

    emitDependentData$ = this.getDepenedentDetails.asObservable();
    emitTokenNotification$ = this.getTokenNotification$.asObservable();
    changeEmitted$ = this.emitChangeSource.asObservable();
    sideBarEmitted$ = this.emitSideBarSource.asObservable();
    dropdownChangesEmitted$ = this.emitChangeValue.asObservable();
    argsChangesEmitted$ = this.emitArgsChanges.asObservable();
    resetChangeEmitted$ = this.emitResetResource.asObservable();
    resetFormEmitted$ = this.resetOtpForm.asObservable();
    getcartData$ = this.cartData.asObservable();
    getMachineId$ = this.machine_id.asObservable();
    emitComponentClass$ = this.componentClass.asObservable();
    emitbtnObser = this.emitArgsChanges.asObservable();
    emitCalendar = this.calendarResource.asObservable();
    bannerRefersh$ = this.bannerRefersh.asObservable();
    storagevalueEmitted$ = this.storagevalue.asObservable();
    appendHtmlEmitted$ = this.appendHtml.asObservable();
    isCimsEmitted$ = this.isCims.asObservable()
    itemInvalidEmitted$ = this.itemInvalid.asObservable()
    hasBillAuthData$ = this.billAuthData.asObservable();
    PoAllData$ = this.PoData$.asObservable();
    grnAllData$ = this.grnData$.asObservable();
    prAllData$ = this.prData$.asObservable();
    indentStoreReturn$ = this.indentData$.asObservable();
    checkKycStatus$ = this.kycStatus$.asObservable();
    emittedDate$ = this.machineDate$.asObservable();
    update_list_ca$ = this.updateCompositeArrayOutSource.asObservable();
    getcurrentBtnValue$ = this.currentBtnValue$.asObservable();
    getEmrOPthalmicValue$ = this.emrOpthalmic_data$.asObservable();
    getCommonViwerData$ = this.commonViwerData$.asObservable();
    emitclearCart$ = this.clearCart$.asObservable();
    emitslotDetails$ = this.slotDetails$.asObservable();
    getConsginmentDetails$ = this.consigmentDetails$.asObservable();
    getConsignmentChallanIssueDetails$ = this.consignmentChallanIssueData$.asObservable();
    getConsginmentReturnDetails$ = this.consigmentReturnDetails$.asObservable();
    getMultipleSlotCount$ = this.multipleSlotCount$.asObservable();
    emitAccessionIdentifierReady$ = this.accessionIdentifierReady$.asObservable();

    setTokenValue(data: any) {
        this.getTokenNotification$.next(data);
    }
    setConsignmentData(data: any) {
        this.consigmentDetails$.next(data);
    }
    setConsignmentChallanIssueData(data: any) {
        this.consignmentChallanIssueData$.next(data);
    }

    setConsignmentReturnData(data: any) {
        this.consigmentReturnDetails$.next(data);
    }

    emitMachineId(data: any) {
        this.machine_id.next(data);
    }

    setslotDetails(data: any) {
        this.slotDetails$.next(data);
    }

    emitChange(data: {}) {
        this.emitChangeSource.next(data);
    }

    clearCart(data) {
        this.clearCart$.next(data);
    }

    emitSidebar(data: {}) {
        this.emitSideBarSource.next(data);
    }

    emitDateTimeChanges(data: {}) {
        this.emitChangeValue.next(data)
    }

    emitArgumentChanges(data: {}) {
        this.emitArgsChanges.next(data);
    }

    emitResetChanges(data: {}) {
        this.emitResetResource.next(data);
    }

    emitResetForm(data) {
        this.resetOtpForm.next(data)
    }

    emitCartData(data) {
        this.cartData.next(data);
    }
    emitComponentClass(data) {
        this.componentClass.next(data);
    }

    emitBtn(data) {
        this.emitBtnArgs.next(data);
    }
    emitCalendarData(data) {
        this.calendarResource.next(data);
    }

    emitBannerRefresh(data) {
        this.bannerRefersh.next(data)
    }

    setStorageChange(data: any) {
        this.storagevalue.next(data)
    }

    appendHtmlToCompositeArray(data: any) {
        this.appendHtml.next(data);
    }
    isCimsEnabled(data: any) {
        this.isCims.next(data);
    }
    hasBillAuthData(data: any) {
        this.billAuthData.next(data);
    }
    hasPoData(data: any) {
        this.PoData$.next(data)
    }
    hasGrnData(data: any) {
        this.grnData$.next(data)
    }
    hasPrData(data: any) {
        this.prData$.next(data)
    }
    hasIndentReturnData(data: any) {
        this.indentData$.next(data)
    }
    isItemInvalid(data: any) {
        this.itemInvalid.next(data);
    }
    setDependenetData(data: any) {
        this.getDepenedentDetails.next(data);
    }
    setKycStatus(data: any) {
        this.kycStatus$.next(data);
    }
    setMachineDateDate$(data: any) {
        this.machineDate$.next(data);
    }
    modifyCompositeArrayOutSource(data: any) {
        this.updateCompositeArrayOutSource.next(data);
    }
    setcurrentBtnValue$(data: any) {
        this.currentBtnValue$.next(data);
    }
    setEmrOpThalmicValue$(data: any) {
        this.emrOpthalmic_data$.next(data);
    }
    setCommonViwerData$(data: any) {
        this.commonViwerData$.next(data)
    }
    setMultipleSlotCount$(data: any) {
        this.multipleSlotCount$.next(data);
    }
}